import * as config from './config.ts';
import * as getCommand from './get.ts';
import * as setCommand from './set.ts';

export { config, getCommand, setCommand };
